/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AdminUpdateUserInput = {
    clientMutationId: string;
    name?: string | null;
    tenantId: string;
    tenantRoleIds: Array<string | null>;
    userId: string;
};
export type useAdminUpdateUserMutationVariables = {
    input: AdminUpdateUserInput;
    tenantId: string;
};
export type useAdminUpdateUserMutationResponse = {
    readonly adminUpdateUser: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly user: {
            readonly id: string;
            readonly name: string;
            readonly displayName: string;
            readonly email: string;
            readonly assignedRoles: {
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly identifier: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type useAdminUpdateUserMutation = {
    readonly response: useAdminUpdateUserMutationResponse;
    readonly variables: useAdminUpdateUserMutationVariables;
};



/*
mutation useAdminUpdateUserMutation(
  $input: AdminUpdateUserInput!
  $tenantId: ID!
) {
  adminUpdateUser(input: $input) {
    errors {
      code
      path
      message
      type
    }
    user {
      id
      name
      displayName
      email
      assignedRoles(objectId: $tenantId, first: 100) {
        edges {
          cursor
          node {
            id
            name
            identifier
            __typename
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "concreteType": "InputError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    } as any, v7 = {
        "kind": "Variable",
        "name": "objectId",
        "variableName": "tenantId"
    } as any, v8 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "RoleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "identifier",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        } as any,
        (v7 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useAdminUpdateUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AdminUpdateUserPayload",
                    "kind": "LinkedField",
                    "name": "adminUpdateUser",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                {
                                    "alias": "assignedRoles",
                                    "args": [
                                        (v7 /*: any*/)
                                    ],
                                    "concreteType": "RoleConnection",
                                    "kind": "LinkedField",
                                    "name": "__user_assignedRoles_connection",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useAdminUpdateUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AdminUpdateUserPayload",
                    "kind": "LinkedField",
                    "name": "adminUpdateUser",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "RoleConnection",
                                    "kind": "LinkedField",
                                    "name": "assignedRoles",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "filters": [
                                        "objectId"
                                    ],
                                    "handle": "connection",
                                    "key": "user_assignedRoles",
                                    "kind": "LinkedHandle",
                                    "name": "assignedRoles"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e7e4be0473df77313f360719ba899b4c",
            "id": null,
            "metadata": {},
            "name": "useAdminUpdateUserMutation",
            "operationKind": "mutation",
            "text": "mutation useAdminUpdateUserMutation(\n  $input: AdminUpdateUserInput!\n  $tenantId: ID!\n) {\n  adminUpdateUser(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n    user {\n      id\n      name\n      displayName\n      email\n      assignedRoles(objectId: $tenantId, first: 100) {\n        edges {\n          cursor\n          node {\n            id\n            name\n            identifier\n            __typename\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '614d2e90fb0bc63db0e448dc6cc62fbc';
export default node;
